module.exports = __webpack_public_path__ + "static/media/arrowtop.e9bfb82e.webp";